import React from 'react';
import { compose, withHandlers } from 'recompose';

import { FormTitle, TextInput, Dropdown } from 'components/Core/Forms';
import { getDistinctQuestions } from 'utils/product';

const enhance = compose(
  withHandlers({
    onChange: props => (value, questionId) => {
      const { questions } = props.book;
      props.onChange('questions', {
        ...questions,
        [questionId]: value
      });
    }
  })
);

const TicketQuestionForm = props => {
  const { selectedTier, book, onChange } = props;
  const questionsExceptDate = getDistinctQuestions(selectedTier).filter(q => q.type !== 'DATE');
  if (questionsExceptDate.length === 0) return null;
  return (
    <div>
      <FormTitle>Ticket Information</FormTitle>
      {questionsExceptDate.map(q => {
        if (q.type === 'FREETEXT') {
          return (
            <TextInput
              key={q.id}
              label={q.question}
              onChange={e => onChange(e.target.value, q.id)}
              value={book.questions[q.id]}
            />
          );
        } else if (q.type === 'OPTION') {
          return (
            <Dropdown
              key={q.id}
              label={q.question}
              options={q.options.map(option => ({ label: option, value: option }))}
              onChange={v => onChange(v, q.id)}
            />
          );
        }
        return null;
      })}
    </div>
  );
};

export default enhance(TicketQuestionForm);



// WEBPACK FOOTER //
// ./src/components/Form/TicketQuestionForm.js